import request from '@/src/apis/axios';
import {
  DeleteRecyclingCouponRequestBody,
  GetRecyclingCouponByIdRequestParams,
  GetRecyclingCouponsRequestParams,
  PostRecyclingCouponRequestBody,
  PutRecyclingCouponRequestBody,
} from '@/src/apis/rest/recyclingCoupon.dtos';
import { RecyclingCouponDto } from '@/src/models/RecyclingCouponDto';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';

const URL = {
  recyclingCoupon: '/admin/recycling-coupons',
  recyclingCouponDetail: '/admin/recycling-coupons/{id}',
  recyclingCouponExcel: '/admin/recycling-coupons/excel/export',
};

// 배송비 쿠폰 리스트 조회
export const getRecyclingCouponsAPI = async (
  requestParams: Partial<GetRecyclingCouponsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<RecyclingCouponDto>>({
    method: 'get',
    url: URL.recyclingCoupon,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(RecyclingCouponDto, data.rows);

  return { rows, count: data.count };
};

// 배송비 쿠폰 상세 조회
export const getRecyclingCouponByIdAPI = async ({
  id,
}: Partial<GetRecyclingCouponByIdRequestParams>) => {
  const { data } = await request<ObjectResponse<RecyclingCouponDto>>({
    method: 'get',
    url: URL.recyclingCouponDetail.replace('{id}', String(id)),
  });

  return plainToInstance(RecyclingCouponDto, data.row);
};

// 배송비 쿠폰 등록
export const postRecyclingCouponAPI = async (
  requestBody: PostRecyclingCouponRequestBody,
) => {
  const { data } = await request<ObjectResponse<RecyclingCouponDto>>({
    method: 'post',
    url: URL.recyclingCoupon,
    requestBody,
  });

  return plainToInstance(RecyclingCouponDto, data.row);
};

// 배송비 쿠폰 수정
export const putRecyclingCouponAPI = async (
  requestBody: PutRecyclingCouponRequestBody,
) => {
  const { id, ...rest } = requestBody;

  const { data } = await request<ObjectResponse<RecyclingCouponDto>>({
    method: 'put',
    url: URL.recyclingCouponDetail.replace('{id}', String(id)),
    requestBody: rest,
  });

  return plainToInstance(RecyclingCouponDto, data.row);
};

// 배송비 쿠폰 수정
export const deleteRecyclingCouponAPI = async ({
  id,
}: DeleteRecyclingCouponRequestBody) => {
  return await request<void>({
    method: 'delete',
    url: URL.recyclingCouponDetail.replace('{id}', String(id)),
  });
};

// 배송비 쿠폰 엑셀 다운로드
export const getRecyclingCouponExcelAPI = async (
  password: string,
  requestParams: Partial<GetRecyclingCouponsRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.recyclingCouponExcel,
    queryParams: { ...requestParams, password },
    config: { responseType: 'blob' },
  });

  return data;
};
